import {Action} from '@ngrx/store';

export const EUISAPConnections = {
  GetAllDestinations: 'Get destinations of type HTTP and Proxy OnPremise',  
  GetAllDestinationsSuccess: 'Success - Get destinations of type HTTP and Proxy OnPremise',
  GetSAPConfiguration: 'Get SAP Configuration for update',
  GetSAPConfigurationSuccess: 'GET SAP CONFIGURATION SUCCESS',
  UpdateSAPCPConfiguration: 'Update SAP CP configuration',
  GetSAPConfigurations: 'Get SAP Configurations for update',
  GetSAPConfigurationsSuccess: 'GET SAP CONFIGURATIONS SUCCESS',
  UpdateSAPCPConfigurationSuccess: 'Update SAP CP was succesful'
};


export class GetAllDestinations implements Action {
  public readonly type = EUISAPConnections.GetAllDestinations;
  constructor(public payload: string, public content: any) {}
}

export class GetAllDestinationsSuccess implements Action {
  public readonly type = EUISAPConnections.GetAllDestinationsSuccess;

  constructor(public payload: ISAPDestination[]) {
  }
}

export class GetSAPConfiguration implements Action {
  public readonly type = EUISAPConnections.GetSAPConfiguration;

  constructor(public payload: string) {
  }
}

export class GetSAPConfigurationSuccess implements Action {
  public readonly type = EUISAPConnections.GetSAPConfigurationSuccess;

  constructor(public payload: ISAPConfiguration) {
  }
}

export class GetSAPConfigurations implements Action {
  public readonly type = EUISAPConnections.GetSAPConfigurations;

  constructor() {
  }
}


export class GetSAPConfigurationsSuccess implements Action {
  public readonly type = EUISAPConnections.GetSAPConfigurationsSuccess;

  constructor(public payload: ISAPConfiguration[]) {
  }
}

export class UpdateSAPConfiguration implements Action {
  public readonly type = EUISAPConnections.UpdateSAPCPConfiguration;

  constructor(public payload: ISAPConfiguration, public guid: string) {
  }

}

export class UpdateSAPConfigurationSuccess implements Action {
  public readonly type = EUISAPConnections.UpdateSAPCPConfigurationSuccess;

  constructor(public payload: boolean) {
  }

}






